import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/promocode/promocode_shadow.png';

const StyledContainer = styled.div<{ $complete?: boolean }>`
	position: relative;
	display: grid;
	grid-template-columns: 1fr 150px;
	width: 100%;
	min-width: 600px;
	height: 170px;
	border-radius: 5px;
	background-color: rgba(
		255,
		255,
		255,
		${(props) => (props.$complete ? 0.05 : 0.02)}
	);
	border: 1px solid
		rgba(255, 255, 255, ${(props) => (props.$complete ? 0.1 : 0.05)});
	transition: background 0.3s ease;
	overflow: hidden;
`;

const StyledShadow = styled.div<{ $complete?: boolean }>`
	position: absolute;
	top: 50%;
	left: -450px;
	transform: translateY(-50%);
	width: 900px;
	height: 900px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	opacity: ${(props) => (props.$complete ? 1 : 0)};
	transition: opacity 0.3s ease;
`;

const StyledProgressContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
`;

const StyledProgressTextContainer = styled.div<{ $complete?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		&:first-child {
			font-size: 14px;
			color: ${(props) =>
				props.$complete ? '#00FF37' : 'rgba(255, 255, 255, 0.25)'};
		}

		&:last-child {
			font-weight: 700;
			font-size: 14px;
			color: ${(props) => (props.$complete ? '#00FF37' : '#FABE2C')};

			span {
				font-size: 12px;
				font-weight: 400;
				color: rgba(255, 255, 255, 0.25);
			}
		}
	}
`;

const StyledProgressBgWrapper = styled.div`
	width: 100%;
	height: 20px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	padding: 1px;
`;

const StyledProgressBg = styled.div<{ $complete?: boolean }>`
	height: 16px;
	background: ${(props) => (props.$complete ? '#1F8034' : '#FABE2C')};
	transition: background 0.3s ease;
	border-radius: 3px;
	transition: width 0.3s ease;
`;

const StyledLeftContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 17px 20px 20px;
	z-index: 2;
`;

const StyledLeftTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 13px;

	${Text} {
		color: #ffffff;
	}
`;

const StyledItemsContainer = styled.div<{ $complete?: boolean }>`
	display: grid;
	grid-template-columns: 60px 60px;
	grid-template-rows: 60px 60px;
	gap: 10px;
	opacity: ${(props) => (props.$complete ? 0.25 : 1)};
	transition: opacity 0.3s ease;
`;

const StyledItemContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	img {
		object-fit: contain;
	}
`;

const StyledRightContainer = styled.div<{ $complete?: boolean }>`
	position: relative;
	width: 130px;
	height: 130px;
	margin-top: 20px;
`;

const StyledCompleteContainer = styled.div<{ $complete?: boolean }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	border-radius: 60px;
	cursor: pointer;
	background-color: #1782ff;
	transition: background-color 0.3s ease;
	opacity: ${(props) => (props.$complete ? 1 : 0)};
	pointer-events: ${(props) => (props.$complete ? 'auto' : 'none')};
	transition: opacity 0.3s ease;

	img {
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledTimerProgressContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 14px;
	width: 100%;
	height: 100%;
`;

const StyledDivider = styled.div`
	width: 1px;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.05);
`;

export {
	StyledCompleteContainer,
	StyledContainer,
	StyledDivider,
	StyledItemContainer,
	StyledItemsContainer,
	StyledLeftContainer,
	StyledLeftTextContainer,
	StyledProgressBg,
	StyledProgressBgWrapper,
	StyledProgressContainer,
	StyledProgressTextContainer,
	StyledRightContainer,
	StyledShadow,
	StyledTimerProgressContainer,
};
